export enum PreferenceOptions {
  DEFAULT_AUTHORITY_SERVICE = 'defaultAuthorityService'
}
